import React from "react"
import Helmet from "react-helmet"
import { useStaticQuery, graphql } from "gatsby"

import SEO from "../../../components/seo"

import Menu from "../../../components/ug-menu/menu"

const MenuPage = () => {
  const data = useStaticQuery(graphql`
    query {
      strapi {
        brand(id: "1") {
          id
          title
          slug
          className
          image {
            url
          }
          outlets {
            id
            title
            menus (sort: "order") {
              title
              order
              file {
                url
              }
            }
          }
        }
      }
    }
  `)
  const blocks = data.strapi.brand
  const menus = blocks.outlets.find(x => x.title === "Pacific Place CC")
  return (
    <>
      <SEO
        title={`${blocks.title} Menu`}
        description="A chef-driven, gourmet food concept serving all-day breakfast, decadent desserts and coffee."
      />
      <Helmet>
        <body className={`bd-menu-landing ${blocks.className}`} />
      </Helmet>

      <Menu
        loaderImg={`https://qrweb-urea-lss9.antikode.dev${blocks.image[1].url}`}
        loaderAlt={blocks.title}
        headerImg={`https://qrweb-urea-lss9.antikode.dev${blocks.image[0].url}`}
        headerAlt={blocks.title}
        headerOutlet="Pacific Place"
        menus={
          menus?.menus?.map((value, i) => {
            return {
              title: value.title,
              link: value.file.url
            }
          })
        }
        paymentLink="http://hungree.id/cashier"
        slug={blocks.slug}
        branch="Pacific Place"
      />
    </>
  )
}

export default MenuPage
